
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import MyTabs from './components/Tabs/index.vue'
import { Observer } from 'mobx-vue'

@Observer
@Component({
  components: {
    MyTabs
  }
})
export default class MyPage extends Vue {
  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
